import React from "react";
import {
  ContentBody,
  ContentHeading,
  ContentLayout,
  OrganizationBx,
  OrganizationEmDetails,
} from "../../style";
import {
  Box,
  Col,
  Dialog,
  Divider,
  FabButton,
  Flex,
  Gap,
  Icon,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../../ppui";
import {
  TbCalendar,
  TbCalendarCheck,
  TbClock,
  TbFileInfo,
  TbFileText,
  TbMessageDots,
  TbPaperclip,
  TbPencil,
} from "react-icons/tb";

const EmPortalLeave = () => {
  const [LeaveEdit, setLeave] = React.useState(false);
  const LeaveModalOpen = () => setLeave(true);
  const LeaveModalClose = () => setLeave(false);
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Leave
          </Typography>
        </ContentHeading>

        <ContentBody Padding>
          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Leave One
            </Typography>
            <FabButton
              size="sm"
              icon={<TbPencil />}
              onClick={LeaveModalOpen}
              variant="filled"
              shape="box"
            />
          </Flex>
          <Gap height={30} />
          <OrganizationEmDetails>
            <OrganizationBx>
              <Icon size={"lg"}>
                <TbFileText />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Leave Type
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  Casual Leave
                </Typography>
              </Box>
            </OrganizationBx>

            <OrganizationBx>
              <Icon size={"lg"}>
                <TbCalendar />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Apply Duration
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  15th November, 2024
                </Typography>
              </Box>
            </OrganizationBx>

            <OrganizationBx>
              <Icon size={"lg"}>
                <TbMessageDots />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Reason
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  I am requesting medical leave due to health issues
                </Typography>
              </Box>
            </OrganizationBx>

            <OrganizationBx>
              <Icon size={"lg"}>
                <TbPaperclip />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Attachment
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  Apollo Hospital Medical Certificate.pdf
                </Typography>
              </Box>
            </OrganizationBx>
          </OrganizationEmDetails>

          <Divider gap={20} />

          <Flex justifyContent="space-between" gap={"10"}>
            <Typography variant="h5" mb={"0"}>
              Leave Two
            </Typography>
            <FabButton
              size="sm"
              icon={<TbPencil />}
              onClick={LeaveModalOpen}
              variant="filled"
              shape="box"
            />
          </Flex>
          <Gap height={30} />
          <OrganizationEmDetails>
            <OrganizationBx>
              <Icon size={"lg"}>
                <TbCalendarCheck />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Leave Type
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  Casual Leave
                </Typography>
              </Box>
            </OrganizationBx>

            <OrganizationBx>
              <Icon size={"lg"}>
                <TbClock />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Apply Duration
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  15th November, 2024
                </Typography>
              </Box>
            </OrganizationBx>

            <OrganizationBx>
              <Icon size={"lg"}>
                <TbFileInfo />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Reason
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  I am requesting medical leave due to health issues
                </Typography>
              </Box>
            </OrganizationBx>

            <OrganizationBx>
              <Icon size={"lg"}>
                <TbPaperclip />
              </Icon>
              <Box>
                <Typography variant="body2" mb={"0"}>
                  Attachment
                </Typography>
                <Typography variant="body1" mb={"0"} color="primary">
                  Apollo Hospital Medical Certificate.pdf
                </Typography>
              </Box>
            </OrganizationBx>
          </OrganizationEmDetails>
        </ContentBody>
      </ContentLayout>

      <Dialog
        title="Leave"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        open={LeaveEdit}
        onClose={LeaveModalClose}
        separator
      >
        <Row rowGap={20}>
          <Col sm={12} md={6}>
            <SelectField
              fullWidth
              required
              label="Leave Type"
              options={[
                { id: "option1", name: "Casual Leave" },
                { id: "option2", name: "Medical Leave" },
                { id: "option3", name: "Privilege Leave" },
                { id: "option4", name: "LOP" },
              ]}
              defaultValue="fixed"
              placeholder="Select Here..."
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Apply Duration"
              type="date"
              placeholder="Type Here..."
              valueSinc={true}
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Reason"
              type="text"
              placeholder="Type Here..."
            />
          </Col>

          <Col sm={12} md={6}>
            <InputField
              required
              fullWidth
              label="Attachment"
              type="file"
              placeholder="Select Here..."
              valueSinc="true"
            />
          </Col>
        </Row>
      </Dialog>
    </>
  );
};

export default EmPortalLeave;
